export const HOME_WELCOME_MESSAGE = 'Please sign in to your account or create a new';
export const HOME_WELCOME_TITLE = 'Welcome to notes';

export const HOME_WELCOME_MESSAGE_WITH_AUTH = 'Please go to the "Notes" page to manage your notes';
